module.exports = __webpack_public_path__ + "img/bg_index_course_01.037bae90.png";